import { useGetCurrentUser } from '@/hooks/api/users/useGetCurrentUser';
import { useFeatureFlags } from '@/hooks/useFeatureFlags';

export const useCanLabel = (): boolean => {
  const { permissions } = useGetCurrentUser();
  const { isTaxonomyEnabled } = useFeatureFlags();
  return isTaxonomyEnabled && permissions.canSetAssetLabels;
};
